import { DivisionDeNegocioOpcion } from '../pages/usuarios/models'

/**@description Retorna un booleano comprobando si hubo cambios en las divisiones de negocio,
 *              comprueba la longitud de un arreglo formado por los elementos que coincide
 *              con la longitud del arreglo que se enviará y el que ya existía.
 *
 * @author andres.martinez, Hábil MX
 * @version 1.0.0, 25/04/2023 */
export const CompararDivisiones = (
  DivNegOriginal: DivisionDeNegocioOpcion[] | undefined,
  DivNegActual: DivisionDeNegocioOpcion[]
) => {
  const right: DivisionDeNegocioOpcion[] = []

  DivNegOriginal?.forEach((d: DivisionDeNegocioOpcion) => {
    DivNegActual.forEach((s: DivisionDeNegocioOpcion) => {
      if (d.nombre === s.nombre && d.descripcion === s.descripcion) {
        right.push(d)
      }
    })
  })

  return right.length === DivNegActual.length && right.length === DivNegOriginal?.length
}
